import { Alert, Modal, Typography } from "antd";
import { PASSWORD_RESET_CONFIRM_TEXT, type AccountCommandError } from "./userAccountAdminApi";

/**
 * S2.3.5 — modal xác nhận "Gửi email đặt lại mật khẩu" (§13.2/§13.3).
 * AntD Modal qua NccAntdProvider: trap focus, ESC/Hủy, focus return mặc định.
 * Copy là VERBATIM từ spec — giải thích boundary: NCC không xem/đặt mật khẩu.
 */
export function UserAccountPasswordResetModal({
  open,
  submitting,
  error,
  onCancel,
  onConfirm,
}: {
  readonly open: boolean;
  readonly submitting: boolean;
  readonly error: AccountCommandError | null;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}) {
  return (
    <Modal
      open={open}
      title="Gửi email đặt lại mật khẩu"
      okText="Gửi yêu cầu"
      cancelText="Hủy"
      okButtonProps={{ disabled: submitting, loading: submitting }}
      cancelButtonProps={{ disabled: submitting }}
      mask={{ closable: false }}
      onCancel={onCancel}
      onOk={onConfirm}
    >
      {error && (
        // ERROR_SUPPORT: mã hỗ trợ chỉ hiện khi lỗi; không raw code, không metadata IdP.
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          title="Không thể thực hiện thao tác"
          description={error.requestId ? `Mã hỗ trợ: ${error.requestId}` : undefined}
        />
      )}
      <Typography.Paragraph>{PASSWORD_RESET_CONFIRM_TEXT}</Typography.Paragraph>
    </Modal>
  );
}
